function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("circle", {
  id: "a",
  cx: 11,
  cy: 11,
  r: 11
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(1 1)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("g", {
  fill: "#30BCB3",
  mask: "url(#b)"
}, React.createElement("path", {
  d: "M-49.5-49.5h121v121h-121z"
})), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.093 8.525a.514.514 0 0 0-.514.514v1.54H9.04a.514.514 0 1 0 0 1.027h1.54v1.54a.514.514 0 1 0 1.027 0v-1.54h1.54a.514.514 0 0 0 0-1.027h-1.54V9.04a.514.514 0 0 0-.513-.514zm-3.771-.803h7.734v1.384c0 .348.418.518.658.27l2.158-2.157a.383.383 0 0 0 0-.55l-2.158-2.157a.387.387 0 0 0-.658.278v1.385H6.548a.776.776 0 0 0-.773.773v3.094c0 .425.348.773.773.773a.776.776 0 0 0 .774-.773v-2.32zm7.744 6.647H7.33v-1.385a.383.383 0 0 0-.657-.27L4.516 14.87a.383.383 0 0 0 0 .55l2.158 2.158c.24.24.657.07.657-.279v-1.384h8.508a.776.776 0 0 0 .774-.774v-3.094a.776.776 0 0 0-.774-.773.776.776 0 0 0-.773.773v2.32z",
  mask: "url(#b)"
})), React.createElement("path", {
  d: "M0 0h24v24H0z"
}));
var SvgTrace = function SvgTrace(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trace.ee8f8b85.svg";
export { ForwardRef as ReactComponent };